import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const SEO = ({ title, description }) => {
    const { t } = useTranslation();
    const baseTitle = "UmaMusume Calculator";
    const fullTitle = title ? `${title} | ${baseTitle}` : baseTitle;
    const metaDesc = description || t('SEO.default_description', "Calculador de score para personajes del juego Umamusume Pretty Derby");

    return (
        <Helmet>
            {/* Standard Metadata */}
            <title>{fullTitle}</title>
            <meta name="description" content={metaDesc} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={metaDesc} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={metaDesc} />
        </Helmet>
    );
};

export default SEO;
